import React from "react";
import { Button } from "@/components/ui/button";
import Text from "@/components/ui/text";
import Modal from "@/components/controls/Modal";
import { useTranslation } from "react-i18next";

interface CreateNewOptionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateOption: (optionName: string) => Promise<void>;
  optionName: string;
}

const TRANSLATION_KEY =
  "settings.userManagement.addNewUserModal.createNewOptionModal";

const CreateNewOptionModal: React.FC<CreateNewOptionModalProps> = ({
  isOpen,
  onClose,
  onCreateOption,
  optionName
}) => {
  const { t } = useTranslation();

  const handleCreate = async () => {
    await onCreateOption(optionName);
    onClose();
  };

  return (
    <Modal
      open={isOpen}
      setIsOpen={(open) => !open && onClose()}
      title={
        <Text variant="title3H1">
          {t(`${TRANSLATION_KEY}.title`, {
            optionName
          })}
        </Text>
      }
      content={
        <div className="flex flex-col gap-4 p-6">
          <Text variant="body">{t(`${TRANSLATION_KEY}.description`)}</Text>
        </div>
      }
      footer={
        <div className="flex items-center justify-end gap-3">
          <Button variant="secondaryNoBg" onClick={onClose}>
            {t("cancel")}
          </Button>
          <Button onClick={handleCreate}>
            {t(`${TRANSLATION_KEY}.create`)}
          </Button>
        </div>
      }
      contentClassname="max-w-md"
      hideDivider={true}
    />
  );
};

export default CreateNewOptionModal;
